import React from 'react';
import "./SelectClearIcon.scss";

function SelectClearIcon() {
	return (
		<i className="material-icons select-clear-icon">close</i>
	)
}

export default SelectClearIcon;